(() => {
  if (window.Shopify?.theme?.role !== 'main') return;
  const publish = (name, data) => {
    const shopify = window.Shopify;
    if (typeof shopify?.customerPrivacy?.analyticsProcessingAllowed !== 'function') return false;
    if (!shopify.customerPrivacy.analyticsProcessingAllowed()) return false;
    if (typeof shopify.analytics?.publish !== 'function') return false;
    try { Promise.resolve(shopify.analytics.publish(name, data)).catch(() => {}); return true; } catch { return false; }
  };
  document.addEventListener('click', (event) => {
    const link = event.target instanceof Element ? event.target.closest('a[data-bp-action]') : null;
    if (!link) return;
    publish('blue_pepper:shopping_path_clicked', {
      action: link.dataset.bpAction,
      flavour: link.dataset.bpFlavour || '',
      product_handle: link.dataset.bpProduct || ''
    });
  });
  document.addEventListener('submit', (event) => {
    if (!(event.target instanceof HTMLFormElement) || !event.target.classList.contains('bp-wholesale-form__form')) return;
    try { sessionStorage.removeItem('bp-wholesale-success:' + event.target.id); } catch {}
  });
  const success = document.querySelector('[data-bp-wholesale-success]');
  if (success) {
    const key = 'bp-wholesale-success:' + success.dataset.bpWholesaleSuccess;
    let recorded = false;
    try { recorded = sessionStorage.getItem(key) === '1'; } catch {}
    const recordSuccess = () => {
      if (recorded) return;
      if (!publish('blue_pepper:wholesale_enquiry_submitted', { form_type: 'wholesale' })) return;
      recorded = true;
      try { sessionStorage.setItem(key, '1'); } catch {}
    };
    recordSuccess();
    document.addEventListener('visitorConsentCollected', recordSuccess);
  }
})();
